import styled from "styled-components";

export const VideoPlayerModalStyle = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: default;
  z-index: 10000;
  .video {
    position: relative;
    max-width: 600px;
    width: 100%;
    background-color: #fff;
    border-radius: 12px;
    .top {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      .title {
        margin-bottom: 0;
      }
    }
    .body {
      padding: 35px 40px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      iframe {
        border-radius: 12px;
      }
    }
    .footer {
      padding: 20px;
      display: flex;
      justify-content: end;
    }
  }
  .close {
    cursor: pointer;
    svg {
      width: 25px;
      height: 25px;
      stroke: red;
    }
  }
`;
